import React from 'react';
import {flightDuration} from '../../../../utility';

const duration = (props) => {
    const OD = props.OD;
    
    return <span className={`u-textColorMedium u-fontSize13 u-phone-fontSize11`}>{flightDuration(OD)}</span>
}

export default duration;


// WEBPACK FOOTER //
// ./src/components/Flight/Airline/AirlineDuration/AirlineDuration.js